import { z } from 'zod';
import {
  IdSchema,
  ImageRefSchema,
  IsoDateSchema,
  SlugSchema,
} from './primitives.js';

export const OrganizerSchema = z.object({
  id: IdSchema,
  slug: SlugSchema,
  name: z.string(),
  bio: z.string().optional(),
  avatar: ImageRefSchema.optional(),
  cover: ImageRefSchema.optional(),
  city: z.string().optional(),
  followerCount: z.number().int().nonnegative().default(0),
  activeEventsCount: z.number().int().nonnegative().default(0),
  createdAt: IsoDateSchema,
  updatedAt: IsoDateSchema,
});

export type Organizer = z.infer<typeof OrganizerSchema>;
